module.exports = __webpack_public_path__ + "img/svg/background-error.a65429f62af23110410b3ffc881babf1.svg";